import Box from '~/core/Box'
import Text from '~/core/Text'
import icons from '~/apps/consumer/icons'
import Image from '~/core/Image'

function EmailNotVerified() {
    return (
        <Box
            alignItems="center"
            direction="col"
            position="relative"
            paddingBottom="8px"
            marginTop="150px"
        >
            <Image
                src={icons.information}
                style={{ marginBottom: '16px' }}
                width="84px"
                height="84px"
            />
            <Text
                fontWeight={600}
                fontSize="24px"
                style={{
                    lineHeight: '32px',
                    marginTop: '8px',
                    textAlign: 'center',
                }}
            >
                Email verification required
            </Text>
            <Text
                fontWeight={400}
                fontSize="14px"
                style={{
                    lineHeight: '32px',
                    marginTop: '8px',
                    marginLeft: '34px',
                    marginRight: '34px',
                    textAlign: 'center',
                    color: 'rgba(0, 0, 0, 0.65)',
                }}
            >
                Your email address is not verified and an email was sent, please
                check your email and click verify email address.
            </Text>
        </Box>
    )
}

export default EmailNotVerified
